import { Navigate, useNavigate } from "react-router";
import { getBillingStatus } from "../services/customer-services/customerBillingStatus";
import { useEffect, useState } from "react";

const RequireAuth = ({ children, isCustomer }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken")
    ? JSON.parse(localStorage.getItem("authToken"))
    : null;

  const [billingStatus, setBillingStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isCustomer) {
      getBillingStatus()
        .then((res) => {
          setBillingStatus(res);
        })
        .catch((err) => console.error(err))
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [isCustomer]);

  if (!token) {
    return <Navigate to={"/signIn"} />;
  }

  if (isLoading) {
    return
  }

  if (isCustomer && billingStatus) {
    const { isPlanActive } = billingStatus;

    if (isPlanActive || window.location.pathname.includes('/billing') || window.location.pathname.includes('/settings')) {
      return children
    } else {
      navigate('/billing/plans')
    }
  } else if (isCustomer && !billingStatus) {
    navigate('/billing/plans')
  }

  return children; // Render children directly for non-customers
};

export default RequireAuth;
